<template>
  <div class="batch-import-modal">
    <el-dialog
      title="批量导入商品"
      :visible.sync="visible"
      width="600px"
      append-to-body
      class="import-modal"
      :before-close="handleCancel"
      :close-on-click-modal="false"
    >
      <div class="import-content">
        <div class="form-item">
          <span class="label"> <span class="required">*</span>报名登记表：</span>
          <div>
            <el-upload
              ref="registrationUpload"
              class="upload-file"
              action="/api/third/api/huaWeiUpload/upload/img"
              :auto-upload="false"
              :file-list="registrationFileList"
              :on-change="handleRegistrationChange"
              :on-remove="handleRegistrationRemove"
              :on-success="handleRegistrationSuccess"
              accept=".docx,.doc"
            >
              <el-button
                ><span class="upload-link"><i class="el-icon-plus"></i>上传</span></el-button
              >
              <p slot="tip" class="tip">
                <span class="tips">所有商品会共用这一个报名登记表</span>
                <span class="tip-detail"
                  >单个文件大小5MB，支持扩展名.docx,.doc，仅支持上传一个文件</span
                >
              </p>
            </el-upload>
          </div>
        </div>

        <div class="form-item">
          <span class="label"> <span class="required">*</span>商品信息表：</span>
          <el-upload
            ref="productUpload"
            class="upload-drag"
            drag
            action=""
            :auto-upload="false"
            :file-list="productFileList"
            :on-change="handleProductChange"
            :on-remove="handleProductRemove"
            accept=".xlsx,.xls"
          >
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
          </el-upload>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button class="download-btn" @click="handleDownloadTemplate">下载导入模板</el-button>
        <el-button type="primary" class="confirm-btn" :loading="loading" @click="handleConfirm">
          确定导入
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import to from 'await-to'
import { deGreeProductExcelDownLoad, deGreeProductBatchImport } from '@/api/center'
export default {
  name: 'BatchImportModal',
  data() {
    return {
      visible: false,
      loading: false,
      registrationFileList: [],
      productFileList: [],
      registrationFormUrl: '',
    }
  },
  methods: {
    show() {
      this.visible = true
      this.registrationFileList = []
      this.productFileList = []
      this.registrationFormUrl = ''
    },
    handleCancel() {
      this.visible = false
      this.registrationFileList = []
      this.productFileList = []
      this.registrationFormUrl = ''
    },
    handleRegistrationChange(file, fileList) {
      const fileName = file.name.toLowerCase()
      const validExtensions = ['.docx', '.doc']
      const isValid = validExtensions.some(ext => fileName.endsWith(ext))
      if (!isValid) {
        this.$message.warning('报名登记表仅支持.docx和.doc格式文件')
        if (this.$refs.registrationUpload) {
          this.$refs.registrationUpload.clearFiles()
        }
        this.registrationFileList = []
        return
      }
      if (fileList.length > 0) {
        this.registrationFileList = [fileList[fileList.length - 1]]
        this.registrationFormUrl = ''
      }
    },
    handleRegistrationRemove() {
      this.registrationFileList = []
      this.registrationFormUrl = ''
    },
    handleRegistrationSuccess(response) {
      if (response.data && response.data.videoUploadUrl) {
        this.registrationFormUrl = response.data.videoUploadUrl
      } else if (response.data) {
        this.registrationFormUrl = response.data
      }
      this.doImport()
    },
    handleProductChange(file, fileList) {
      const fileName = file.name.toLowerCase()
      const validExtensions = ['.xlsx', '.xls', '.csv']
      const isValid = validExtensions.some(ext => fileName.endsWith(ext))
      if (!isValid) {
        this.$message.warning('商品信息表仅支持Excel格式文件(.xlsx,.xls,.csv)')
        if (this.$refs.productUpload) {
          this.$refs.productUpload.clearFiles()
        }
        this.productFileList = []
        return
      }
      if (fileList.length > 0) {
        this.productFileList = [fileList[fileList.length - 1]]
      }
    },
    handleProductRemove() {
      this.productFileList = []
    },
    async handleDownloadTemplate() {
      const [res, err] = await to(deGreeProductExcelDownLoad())
      if (err) return this.$message.warning(err.msg)
      let blob = new Blob([res], {
        type: 'application/vnd.ms-excel',
      })
      let url = window.URL.createObjectURL(blob)
      let a = document.createElement('a')
      a.href = url
      a.download = '学历商品模板.xlsx'
      a.click()
      window.URL.revokeObjectURL(url)
    },
    async handleConfirm() {
      if (!this.registrationFileList.length) {
        return this.$message.warning('请先上传报名登记表')
      }
      if (!this.productFileList.length) {
        return this.$message.warning('请先上传商品信息表')
      }

      this.loading = true

      if (!this.registrationFormUrl) {
        this.$refs.registrationUpload.submit()
        return
      }

      await this.doImport()
    },
    async doImport() {
      if (!this.registrationFormUrl) {
        return
      }

      const formData = new FormData()
      formData.append('file', this.productFileList[0].raw)
      formData.append('registrationFormUrl', this.registrationFormUrl)

      const [, err] = await to(deGreeProductBatchImport(formData))
      this.loading = false

      if (err) return this.$message.warning(err.msg)

      this.$message.success('导入成功')
      this.handleCancel()
      this.$emit('success')
    },
  },
}
</script>
<style lang="scss" scoped>
.import-modal {
  ::v-deep .el-dialog__body {
    padding: 20px 20px 0;
  }
  ::v-deep .el-dialog__footer {
    padding: 20px;
    text-align: right;
  }
  .import-content {
    .form-item {
      display: flex;
      margin-bottom: 20px;
      .label {
        display: block;
        font-size: 14px;
        color: #303133;
        margin-bottom: 10px;
        flex-shrink: 0;
        .required {
          color: #f56c6c;
          margin-right: 4px;
        }
      }
      .upload-file {
        .upload-link {
          color: #e6a23c;
          font-size: 14px;
          cursor: pointer;
          .el-icon-plus {
            margin-right: 4px;
          }
        }
      }
      .tips {
        display: block;
        font-size: 14px;
        color: #e6a23c;
        margin-top: 8px;
      }
      .tip-detail {
        display: block;
        font-size: 12px;
        color: #909399;
        margin-top: 4px;
      }
      .upload-drag {
        width: 300px;
        ::v-deep .el-upload {
          width: 100%;
        }
        ::v-deep .el-upload-dragger {
          width: 100%;
          height: 160px;
          background: #fafafa;
          border-radius: 4px;
          border: 1px dashed #d9d9d9;
          display: flex;
          flex-direction: column;
          align-items: center;
          &:hover {
            border-color: #e6a23c;
            background: #fafafa;
          }
          .el-icon-upload {
            font-size: 60px;
            color: #e6a23c;
          }
          .el-upload__text {
            font-size: 14px;
            color: #e6a23c;
            em {
              font-style: normal;
            }
          }
        }
      }
    }
  }
  .dialog-footer {
    .download-btn {
      width: 130px;
      height: 36px;
      border-radius: 4px;
      font-size: 14px;
      border-color: #e6a23c;
      color: #e6a23c;
      &:hover {
        background: rgba(230, 162, 60, 0.1);
        border-color: #e6a23c;
        color: #e6a23c;
      }
    }
    .confirm-btn {
      width: 130px;
      height: 36px;
      border-radius: 4px;
      font-size: 14px;
      background: #e6a23c;
      border-color: #e6a23c;
      &:hover {
        background: #cf9236;
        border-color: #cf9236;
      }
    }
  }
}
</style>
